import axios from 'Axios';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Power, User } from 'tabler-icons-react';
import { Button } from 'Elements';
import { currentUser, api, toastify, Names } from 'Utils';
import Placeholder from 'assets/img/img-user-default.png';
import styles from 'partials/dropdown/dropdown-user.module.scss';

export const DropdownUser = ({ onClose }) => {
	const user = useSelector((state) => state.user);
	const history = useHistory();

	const handleLogout = () => {
		axios.post(api.logout).then((res) => {
			const data = res?.data;
			if (data?.success) {
				toastify('شما با موفقیت از سیستم خارج شدید', 'success');
			}
			currentUser.resetUser();
			onClose?.();
			history.push('/');
		});
	};

	return (
		<div className={styles.box}>
			<header className={styles.header}>
				<img
					src={
						user.info?.avatar ??
						currentUser.getUser()?.avatar ??
						Placeholder
					}
					alt={user.info?.name ?? currentUser.getUser()?.name}
					className={styles.headerImage}
				/>
				<div className={styles.headerContent}>
					<h3 className={styles.headerTitle}>
						{user.info?.username ?? currentUser.getUser()?.username}
					</h3>
					<span className={styles.headerSubTitle}>
						{user.info?.name ?? currentUser.getUser()?.name}
					</span>
				</div>
			</header>
			<div className={styles.body}>
				<ul>
					<li className={styles.list}>
						<Link
							to={Names.profile.path}
							className={styles.listLink}>
							<User className={styles.listIcon} />
							پنل کاربری
						</Link>
					</li>
					<li className={styles.list}>
						<Button
							className={styles.listLink}
							onClick={handleLogout}>
							<Power className={styles.listIcon} />
							خروج از حساب کاربری
						</Button>
					</li>
				</ul>
			</div>
		</div>
	);
};
